<template>
  <div class="">
    <b-modal ref="managegroups" modal-class="managegroupsmodal" size="lg custom-overlay-sm" :lazy="true" :centered="true" :hide-footer="true" @shown="loadIntialData" no-fade>
      <div slot="modal-header" class="w-100">
        <p class="float-left modal-title">Manage Groups</p>
          <close-icon class="icon-default close modalclose"  @click="closeModal"></close-icon>
      </div>
      <div class="h-100 w-100">
        <div class="custom-tab w-100">
          <div class="custom-tab-header">
            Create, Rename, Edit or Delete groups
          </div>
          <div class="custom-tab-body hasfooter">
            <div class="custom-tab-body-cont">
              <b-row class="site-selector-container">
                <b-col cols="flex-column groups-column p-0">
                  <div class="selector-title p-2">
                    <span>Groups</span>
                  </div>
                  <div class="groups-wrapper px-2" style="max-height: 357px;">
                    <ul class="groups-list">
                      <li class="" v-bind:class="{active:currentSelectedGroupID===group.groupID,editmode:group.edit,deletemode:group.showDelete}" v-for="(group,index) in groups" :key="group.groupID" @click="selectGroup(group)">
                        <a class="group-name" v-if="!group.edit">{{group.name}}</a>
                        <input type="text" class="edit-input" :ref="group.groupID" v-model="group.name" v-show="group.edit" @keyup.enter="saveEdit(group,index)" @blur="saveEdit(group,index)">
                        <span class="action-icon-cont" v-if="!group.showDelete && !group.edit">
                          <a @click="toggleEdit(group,index) " v-b-tooltip.hover.top.window title="Rename">
                            <write-icon class="icon-default write-icon"></write-icon>
                          </a>
                          <a @click="deleteGroup(group,index) " v-b-tooltip.hover.top.window title="Delete">
                            <delete-icon class="icon-default delete-icon"></delete-icon>
                          </a>

                        </span>
                        <span>
                          <a @click="saveEdit(group,index)" v-if="group.edit">
                            <tick-icon class="icon-default tick"></tick-icon>
                          </a>
                        </span>
                        <span v-if="group.showDelete" class="delete-confirmer">Sure?
                          <a @click="confirmDelete(group,index)" class="a-btns">Yes</a>
                          <a @click="cancelDelete(group,index)" class="a-btns">No</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </b-col>
                <b-col class="p-0">
                <div class="site-options-cont">
                    <div class="selector-title pr-3">
                      By websites
                    </div>
                  <div class="relative search-input-container manage-groups">
                    <b-input v-model="searchText" class="mb-2 mr-sm-2 mb-sm-0 search-input" id="search_text" type="text" placeholder="Search sites" />
                    <div class="search-icon-container">
                      <magnifier-icon class="icon-default search-icon"></magnifier-icon>
                    </div>
                  </div>
                  <div class="selector-title p-2 ">Select:
                    <a @click="selectAll() ">All</a>
                    <a @click="selectInvert() ">Invert</a>
                    <a @click="selectNone() ">None</a>
                  </div>
                </div>
                  <div class="sites-wrapper ">
                    <b-form-group>
                      <b-form-checkbox-group id="checkboxes2 " name="flavour2 " v-model="selectedSiteIds">
                        <b-form-checkbox class="site-name-cont blue-checked darkbg" size="sm" v-for="(site) in sites " :key="site.siteID " :value="site.siteID ">{{site.name}}</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div class="custom-tab-body-footer ">
          <div class="row ">
            <div class="text-left col-md-6 pl-2">
              <b-form inline v-if="showCreateForm" @submit="createGroup()">
                <b-input class="mb-2 mr-sm-2 mb-sm-0 " ref="groupnameinp" v-model="newGroupName" id="inlineFormInputName2 " placeholder="New group name" />
                <b-button variant="outline-secondary " @click="createGroup() ">Create group</b-button>
                <div v-if="groupNameUniqueError">
                  group name should be unique
                </div>
              </b-form>

              <b-button v-if="!showCreateForm " type="button " variant="outline-secondary " @click="showCreateGroup">Create a New Group</b-button>
            </div>
            <div class="text-right col-md-6 ">
              <b-button type="button " variant="primary " @click="saveChanges" :disabled="buttonLoaders.save">Save Changes
              <spinner size="small" class="" v-if="buttonLoaders.save" ></spinner>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import WriteIcon from "../../assets/write.svg";
import DeleteIcon from "../../assets/delete.svg";
import CloseIcon from "../../assets/close.svg";
import TickIcon from "../../assets/tick.svg";
import MagnifierIcon from '../../assets/lens.svg';
import FormAlert from "../Common/FormAlert";
export default {
  name: "ManageGroups",
  components: {
    WriteIcon,
    DeleteIcon,
    CloseIcon,
    TickIcon,
    MagnifierIcon,
    FormAlert
  },
  data() {
    return {
      groups: [],
      searchText: "",
      showCreateForm: false,
      newGroupName: "",
      newGroupCounter: 0,
      selectedSiteIds: [],
      selectedGroups: [],
      currentSelectedGroupID: "",
      tempGroupChangesBuffer: {},
      newGroupBuffer: {},
      deleteGroupBuffer: {},
      groupNameUniqueError: false,
      groupNameChangeBuffer: {},
      buttonLoaders:{
        save:false
      }
    };
  },
  computed: {
    sites() {
      let sites = _.cloneDeep(this.$store.getters.getSites);
      let filtered =  _.filter(sites, site => {
        return (
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        );
      });
      return _.sortBy(filtered, [data => data.name.toLowerCase()]);
    }
  },
  watch: {
    selectedSiteIds(updatedValue) {
      this.tempGroupChangesBuffer[this.currentSelectedGroupID] = updatedValue;
    }
  },
  methods: {
    loadIntialData() {
      let groups = _.cloneDeep(this.$store.getters.getGroups);
      this.groups =  _.sortBy(groups, [data => data.name.toLowerCase()]);
      if (this.groups.length > 0) {
        this.currentSelectedGroupID = this.groups[0].groupID;
        this.selectGroup(this.groups[0]);
      }
    },
    selectAll() {
      this.selectedSiteIds = _.map(this.sites, site => {
        return site.siteID;
      });
    },
    selectInvert() {
      let tempArray = [];
      _.each(this.sites, site => {
        if (this.selectedSiteIds.indexOf(site.siteID) === -1) {
          tempArray.push(site.siteID);
        }
      });
      this.selectedSiteIds = tempArray;
    },
    selectNone() {
      this.selectedSiteIds = [];
    },
    selectGroup(group) {
      this.selectedSiteIds = [];
      this.currentSelectedGroupID = group.groupID;
      // if (this.tempGroupChangesBuffer[group.groupID]) {
      //   return;
      // }
      _.each(this.sites, site => {
        if (site.groupIDs) {
          let index = site.groupIDs.indexOf(group.groupID);
          if (index > -1) {
            this.selectedSiteIds.push(site.siteID);
          }
        }
      });
    },
    showCreateGroup() {
      this.showCreateForm = true;
      setTimeout(() => {
        this.$refs.groupnameinp.focus();
      }, 100);
    },
    createGroup() {
      let isAlreadyHaveGroup = _.find(this.groups, { name: this.newGroupName });
      if (isAlreadyHaveGroup) {
        console.log("already having same name");
        this.groupNameUniqueError = true;
        return;
      }

      let tempGroupID = `new-${this.newGroupCounter}`;
      this.groups.push({
        name: this.newGroupName,
        groupID: tempGroupID,
        isNewGroup: true
      });
      this.newGroupBuffer[tempGroupID] = this.newGroupName;
      this.showCreateForm = false;
      this.newGroupName = "";
      this.newGroupCounter++;
      this.groupNameUniqueError = false;
    },
    toggleEdit(group, index) {
      //   let editGroup = group);
      group.edit = true;

      this.groups.splice(index, 1, group);
      setTimeout(() => {
        this.$refs[group.groupID][0].focus();
      }, 100);
    },
    deleteGroup(group, index) {
      group.showDelete = true;
      this.groups.splice(index, 1, group);
    },
    confirmDelete(group, index) {
      if (group.isNewGroup) {
        delete this.newGroupBuffer[group.groupID];
        delete this.tempGroupChangesBuffer[group.groupID];
        delete this.groupNameChangeBuffer[group.groupID];
      } else {
        this.deleteGroupBuffer[group.groupID] = group.groupID;
      }
      this.groups.splice(index, 1);
    },
    cancelDelete(group, index) {
      group.showDelete = false;
      this.groups.splice(index, 1, group);
    },
    saveEdit(group, index) {
      this.groupNameChangeBuffer[group.groupID] = group.name;
      group.edit = false;
      this.groups.splice(index, 1, group);
    },
    closeModal() {
      this.$refs.managegroups.hide();
    },
    saveChanges() {
      let payload = {};
      payload.requiredData = {
        manageGroups: {},
        getGroupsSitesV3: 1,
        getSitesV3: 1
      };
      this.buttonLoaders.save = true;
      if (this.newGroupBuffer) {
        payload.requiredData.manageGroups.new = {};
        payload.requiredData.manageGroups.new = this.newGroupBuffer;
      }
      if (this.tempGroupChangesBuffer) {
        _.each(this.tempGroupChangesBuffer, (tempBuffer, groupID) => {
          if (_.isEmpty(tempBuffer)) {
            tempBuffer.push("empty");
          }
        });
        payload.requiredData.manageGroups.updateSites = {};
        // if(this.tempGroupChangesBuffer)
        payload.requiredData.manageGroups.updateSites = this.tempGroupChangesBuffer;
      }
      if (this.groupNameChangeBuffer) {
        payload.requiredData.manageGroups.updateNames = {};
        payload.requiredData.manageGroups.updateNames = this.groupNameChangeBuffer;
      }
      if (this.deleteGroupBuffer) {
        payload.requiredData.manageGroups.delete = {};
        payload.requiredData.manageGroups.delete = this.deleteGroupBuffer;
      }
      this.$store.dispatch("sendAction", payload).then(response => {
        this.buttonLoaders.save = false;
        this.$store.commit("SET_GROUPS", response.data.getGroupsSitesV3);
        this.$store.commit("SET_SITES", response.data.getSitesV3);
        this.closeModal();
      });
    }
  }
};
</script>

<style>

</style>
